import { createContext } from 'react';

const HubContext = createContext({
    hubConnection: null,
    chatNewMessageWarning: []
});

export default HubContext;
